// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── PieChart — Proportional Distribution Visualization ─── */
.PieChart_pie-chart__JteOb {
  padding: 28px 28px 24px;
  background: var(--bg-2, #fff);
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);
  min-width: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.PieChart_pie-chart--embed__qkZIZ {
  padding: 0;
  background: transparent;
  border-radius: 0;
  box-shadow: none;
}
.PieChart_pie-chart__header__EICA2 {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}
.PieChart_pie-chart__title__o34Pf {
  font-family: "Lora", "Georgia", serif;
  font-size: 22px;
  font-weight: 700;
  color: var(--text-1, #1a1a1a);
  line-height: 1.25;
}
.PieChart_pie-chart__subtitle__Nwc-O {
  font-size: 13px;
  font-weight: 400;
  color: var(--grey-text, #888);
  margin-top: 4px;
  line-height: 1.4;
}
.PieChart_pie-chart__grid__rvHVj {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  width: 100%;
  min-width: 0;
}

/* ─── Individual Pie Item ─── */
.PieChart_pie-item__S8sAi {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
  background: rgba(0, 0, 0, 0.015);
  border-radius: 10px;
  padding: 16px 12px 8px;
  transition: box-shadow 0.25s ease;
}
.PieChart_pie-item__S8sAi:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}
.PieChart_pie-item__label__KqmPE {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  text-align: center;
}
.PieChart_pie-item__stat-name__DpDTP {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  line-height: 1.3;
  min-height: 2.6em;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-1, #1a1a1a);
}
.PieChart_pie-item__total__aqWnS {
  font-size: 11px;
  font-weight: 500;
  color: var(--grey-text, #999);
  font-style: italic;
}
.PieChart_pie-item__chart__8YrIK {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 260px;
}

/* ─── Responsive ─── */
@media only screen and (max-width: 1280px) {
  .PieChart_pie-chart__grid__rvHVj {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media only screen and (max-width: 900px) {
  .PieChart_pie-chart__grid__rvHVj {
    grid-template-columns: minmax(0, 1fr);
    gap: 24px;
  }
  .PieChart_pie-item__chart__8YrIK {
    height: 300px;
  }
}
@media only screen and (max-width: 768px) {
  .PieChart_pie-chart__JteOb {
    padding: 20px 16px;
  }
  .PieChart_pie-chart__header__EICA2 {
    flex-direction: column;
    gap: 8px;
  }
  .PieChart_pie-chart__title__o34Pf {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/PieChart/PieChart.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,+DAAA;AAEA;EACE,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,wEAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;AACF;AACE;EACE,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AACJ;AAEE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAAJ;AAGE;EACE,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,iBAAA;AADJ;AAIE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;AAFJ;AAKE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAHJ;;AAOA,gCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;EACA,sBAAA;EACA,iCAAA;AAJF;AAME;EACE,0CAAA;AAJJ;AAOE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AALJ;AAQE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AANJ;AASE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;AAPJ;AAUE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;AARJ;;AAYA,uBAAA;AACA;EAEI;IACE,gDAAA;EAVJ;AACF;AAcA;EAEI;IACE,qCAAA;IACA,SAAA;EAbJ;EAkBE;IACE,aAAA;EAhBJ;AACF;AAoBA;EACE;IACE,kBAAA;EAlBF;EAoBE;IACE,sBAAA;IACA,QAAA;EAlBJ;EAqBE;IACE,eAAA;EAnBJ;AACF","sourcesContent":["/* ─── PieChart — Proportional Distribution Visualization ─── */\n\n.pie-chart {\n  padding: 28px 28px 24px;\n  background: var(--bg-2, #fff);\n  border-radius: 14px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n\n  &--embed {\n    padding: 0;\n    background: transparent;\n    border-radius: 0;\n    box-shadow: none;\n  }\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n  }\n\n  &__title {\n    font-family: \"Lora\", \"Georgia\", serif;\n    font-size: 22px;\n    font-weight: 700;\n    color: var(--text-1, #1a1a1a);\n    line-height: 1.25;\n  }\n\n  &__subtitle {\n    font-size: 13px;\n    font-weight: 400;\n    color: var(--grey-text, #888);\n    margin-top: 4px;\n    line-height: 1.4;\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 16px;\n    width: 100%;\n    min-width: 0;\n  }\n}\n\n/* ─── Individual Pie Item ─── */\n.pie-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n  max-width: 100%;\n  background: rgba(0, 0, 0, 0.015);\n  border-radius: 10px;\n  padding: 16px 12px 8px;\n  transition: box-shadow 0.25s ease;\n\n  &:hover {\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n  }\n\n  &__label {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2px;\n    text-align: center;\n  }\n\n  &__stat-name {\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    line-height: 1.3;\n    min-height: 2.6em;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-1, #1a1a1a);\n  }\n\n  &__total {\n    font-size: 11px;\n    font-weight: 500;\n    color: var(--grey-text, #999);\n    font-style: italic;\n  }\n\n  &__chart {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    height: 260px;\n  }\n}\n\n/* ─── Responsive ─── */\n@media only screen and (max-width: 1280px) {\n  .pie-chart {\n    &__grid {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n  }\n}\n\n@media only screen and (max-width: 900px) {\n  .pie-chart {\n    &__grid {\n      grid-template-columns: minmax(0, 1fr);\n      gap: 24px;\n    }\n  }\n\n  .pie-item {\n    &__chart {\n      height: 300px;\n    }\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .pie-chart {\n    padding: 20px 16px;\n\n    &__header {\n      flex-direction: column;\n      gap: 8px;\n    }\n\n    &__title {\n      font-size: 18px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pie-chart": `PieChart_pie-chart__JteOb`,
	"pie-chart--embed": `PieChart_pie-chart--embed__qkZIZ`,
	"pie-chart__header": `PieChart_pie-chart__header__EICA2`,
	"pie-chart__title": `PieChart_pie-chart__title__o34Pf`,
	"pie-chart__subtitle": `PieChart_pie-chart__subtitle__Nwc-O`,
	"pie-chart__grid": `PieChart_pie-chart__grid__rvHVj`,
	"pie-item": `PieChart_pie-item__S8sAi`,
	"pie-item__label": `PieChart_pie-item__label__KqmPE`,
	"pie-item__stat-name": `PieChart_pie-item__stat-name__DpDTP`,
	"pie-item__total": `PieChart_pie-item__total__aqWnS`,
	"pie-item__chart": `PieChart_pie-item__chart__8YrIK`
};
export default ___CSS_LOADER_EXPORT___;
